import React from "react"

import { subscribe } from "../lib/mailer-lite"

const MDXLink = ({ href, children }) => {
  let rel = "nofollow"
  let isSubscribe = false

  if (href === "/subscribe") {
    isSubscribe = true
  } else if (href.match(/^!/)) {
    href = href.substring(1)
  } else {
    rel = ""
  }

  return (
    <>
      {isSubscribe ? (
        <a
          href={href}
          onClick={e => {
            subscribe(e)
          }}
          onKeyDown={e => {
            subscribe(e)
          }}
        >
          {children}
        </a>
      ) : (
        <a href={href} rel={rel}>
          {children}
        </a>
      )}
    </>
  )
}

export default MDXLink
